/* eslint-disable no-unused-vars */
/* eslint-disable semi */
import { safeDeepGet } from 'iotera-base/utility/json';
import Base from './base';

export default class Pop extends Base {
  constructor(firebase, applicationId) {
    super(firebase, applicationId, 'pop_binding');
  }
  
  list = () => {
    return new Promise((resolve, reject) => {
      const list = {};
      this.collection.orderBy("name").get().then(
        querySnapshot => {
          querySnapshot.docs.map(doc => {
            list[doc.id] = doc.data();
          });
          resolve({ code: 0, body: list });
        },
        error => {
          resolve({ code: -1, body: error });
        }
      );
    });
  };

  listByPopId = () => {
    return new Promise((resolve, reject) => {
      const list = {};
      this.collection.orderBy("name").get().then(
        querySnapshot => {
          querySnapshot.docs.map(doc => {
            const data = doc.data()
            const cross_reff = safeDeepGet(data, 'cross_reff', "")
            list[cross_reff] =data;
          });
          resolve({ code: 0, body: list });
        },
        error => {
          resolve({ code: -1, body: error });
        }
      );
    });
  };

  read = name => {
    return new Promise((resolve, reject) => {
      let map = {};
      this.collection
        .where('name', '==', name)
        .get()
        .then(
          querySnapshot => {
            let code = -1;
            if (querySnapshot.size > 0) {
              code = 0;
              map = { ...querySnapshot.docs[0].data() };
            }
            resolve({ code: code, body: map });
          },
          error => {
            resolve({ code: -1, body: map });
          }
        );
    });
  };

 update = (id, payload) => {
  return new Promise((resolve, reject) => {
    this.collection
      .doc(id)
      .update(payload)
      .then(
        () => {
          resolve({ code: 0 });
        },
        error => {
          console.log('Update failed, trying to create new document:', error);
          this.collection
            .doc(id)
            .set(payload)
            .then(
              () => {
                resolve({ code: 1 }); // 1 = update gagal tapi berhasil push baru
              },
              err => {
                console.log('Set failed too:', err);
                resolve({ code: -1, body: err }); // Gagal total
              }
            );
        }
      );
  });
};


  updateStock = (id, payload) => {
    return new Promise((resolve, reject) => {
      const updatedPayload = {};
      for (const key in payload) {
        if (key === 'name' || key === 'desc' || key === 'warehouse_stock') {
          updatedPayload[key] = payload[key];
        }
      }

      this.collection
        .doc(id)
        .update(updatedPayload)
        .then(
          () => {
            resolve({ code: 0 });
          },
          error => {
            resolve({ code: -1, body: error });
          }
        );
    });
  };

  delete_ = sku => {
    return new Promise((resolve, reject) => {
      this.collection.doc(sku).delete().then(
        () => {
          resolve({ code: 0 });
        },
        error => {
          resolve({ code: -1, body: error });
        }
      );
    });
  };
}
